import { useEffect, useState } from "react";
import { BrowserMermaidPort } from "../features/mermaid/mermaid-adapter";

const LANDING_SOURCE = `flowchart TB
  Source[Operational source] --> Ingest[Ingestion]
  Ingest --> Valid{Contract valid?}
  Valid -->|yes| Curated[Curated dataset]
  Curated --> Consumer[Analytics consumer]
  Valid -->|no| Review[Human review]
  Review --> Ingest
  Enrich[Enrichment<br/>LLM, rules, metadata] -.-> Curated`;

export function LandingDiagram() {
  const [svg, setSvg] = useState("");

  useEffect(() => {
    let active = true;
    void new BrowserMermaidPort().parseAndRender(LANDING_SOURCE).then((result) => {
      if (active && result.ok) setSvg(result.svg);
    });
    return () => { active = false; };
  }, []);

  return (
    <div className="landing-diagram" aria-label="Intent to recoverable handoff workflow">
      {svg ? <div className="landing-diagram-svg" dangerouslySetInnerHTML={{ __html: svg }} /> : <div className="landing-diagram-loading">Preparing the workspace…</div>}
      <div className="landing-source-sample" aria-label="Mermaid source example">
        <span>flowchart LR</span>
        <span>Source --&gt; Ingest --&gt; Valid&#123;Contract valid?&#125;</span>
        <span>Valid -- yes --&gt; Curated --&gt; Consumer</span>
        <span>Valid -- no --&gt; Review --&gt; Ingest</span>
      </div>
      <p className="landing-annotation annotation-source">Source stays editable</p>
      <p className="landing-annotation annotation-handoff">Ready for the next person</p>
    </div>
  );
}
